import React from 'react';

import { Grid, Typography } from '@mui/material';
import SmartDateInput from '../../../customFields/SmartDateInput';
import CommentInput from '../../comment/CommentInput';

const OperationStartDate = () => (
  <Grid container spacing={10}>
    <Grid size={12}>
      <Typography
        color="#646464"
        variant="h6"
      >
        Date business started operating
      </Typography>
    </Grid>
    <Grid
      size={{
        xs: 12,
        md: 6,
      }}
    >
      <SmartDateInput source="value" fullWidth />
    </Grid>
    <Grid size={12}>
      <CommentInput
        source="comment"
        helperText={false}
        placeholder="Please explain your decision."
      />
    </Grid>
  </Grid>
);

export default OperationStartDate;
